import React, { useState, useRef, useEffect } from 'react';
import { showConfirm, showSuccess, showError } from "../../../utils/SweetAlert";
import propTypes from 'prop-types';

import { DateRange } from 'react-date-range';
import { parseISO, addDays, isSameDay } from 'date-fns';

import "./index.scss";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import formatDate from "utils/formatDate";
import iconCalender from 'assets/images/icons/ic_calendar.svg';


export default function Date(props) {
    const { value, placeholder, name, excludeDates } = props;
    const [isShowed, setIsShowed] = useState(false);
    const [focusRange, setFocusRange] = useState([0, 0]);

    const datePickerChange = (value) => {
    const { startDate, endDate } = value.selection;
    const isSame = isSameDay(startDate, endDate);
    const allowSameDay = props.allowSameDay;
    const hasCompleted = startDate && endDate;

    if (focusRange[1] === 1) {
        if (!allowSameDay && isSame) {
            showError("Tanggal tidak valid", "Tanggal check-in tidak boleh sama dengan check-out.");
            return;
        }
    }

    // ❗ Sekarang hasCompleted pasti true, maka bisa tutup
    if ((focusRange[1] === 1 || !isSame) && hasCompleted) {
        setIsShowed(false);
    }

    props.onChange({
        target: {
        value: value.selection,
        name: name,
        },
    });
    };
    
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const refDate = useRef(null);
    const handleClickOutside = event => {
        if (refDate && !refDate.current?.contains(event.target)) {
            setIsShowed(false);
        }
    };

    const check = (focus) => {
        setFocusRange(focus);

        if (focus.indexOf(1) < 0) {
            return;
        }
    };

    const displayDate = `${value.startDate ? formatDate(value.startDate) : ""}${value.endDate ? " - " + formatDate(value.endDate) : ""}`;

    const isDateBooked = (date) => excludeDates.some(
        (excludeDate) => isSameDay(date, excludeDate)
    );

    const disabledDates = excludeDates;

    return (
        <div ref={refDate} className={["input-date mb-3", props.outerClassName].join(" ")}>
            <div className="input-group">
                <div className="input-group-prepend bg-gray-900">
                    <span className="input-group-text">
                        <img src={iconCalender} alt="icon calender" />
                    </span>
                </div>
                <input
                    readOnly
                    type="text"
                    className='form-control'
                    value={displayDate}
                    placeholder={placeholder}
                    onClick={() => setIsShowed(!isShowed)}
                />

                {isShowed && (
                    <div className="date-range-wrapper">
                        <DateRange
                            editableDateInputs={true}
                            onChange={datePickerChange}
                            moveRangeOnFirstSelection={false}
                            onRangeFocusChange={check}
                            ranges={[value]}
                            minDate={value.minDate}
                            // maxDate={addDays(value.maxDate, 30)}
                            disabledDates={disabledDates}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

Date.propTypes = {
    value: propTypes.object,
    onChange: propTypes.func,
    placeholder: propTypes.string,
    outerClassName: propTypes.string,
    allowSameDay: propTypes.bool,
};